<div [ngClass]="{'general-loading': _loading.isLoading }" *blockUI="'componentsPrivateLayout'; message: null">
	<app-header-nav *ngIf="!isPortalClienteRoute"></app-header-nav>

	<!-- Un solo outlet. Si se crea y se destruye al cambiar de cara, la
	     vuelta a la clásica (Services ya cargado) se activa en el outlet
	     que acaba de morir y la pantalla queda en blanco. -->
	<div class="private-outlet" [class.suite-shell]="showSuiteSidebar">
		@if (showSuiteSidebar) {
			<aside class="suite-shell__sidebar">
				<app-suite-modules></app-suite-modules>
			</aside>
		}
		<div class="private-outlet__content" [class.suite-shell__content]="showSuiteSidebar">
			<router-outlet></router-outlet>
		</div>
	</div>
</div>
